<template>
  <div>
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="menu" :rules="rules" :wrapper-col="{span:16}" style="margin-left: -12%;margin-right: 50%">
      <a-row>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuId')">
            <vxe-input v-model="menu.id" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.parentMenu')">
            <vxe-input v-model="menu.parent.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuNo')" prop="no">
            <vxe-input v-model="menu.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuName')" prop="name">
            <vxe-input v-model="menu.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.url')">
            <vxe-input v-model="menu.url" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.icon')">
            <vxe-input v-model="menu.icon" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.application')" prop="application">
            <vxe-select v-model="menu.application" :options="applications" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件名">
            <vxe-input v-model="menu.parameter.component" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件描述">
            <vxe-input v-model="menu.parameter.meta.title" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件图标">
            <vxe-input v-model="menu.parameter.meta.icon" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件参数">
            <vxe-card>
              <a-row style="margin-left: -2%;margin-right: 2%">
                <a-col v-for="item in parameterItems" v-if="menu.parameter.business && menu.parameter.business[item.field]!==undefined" :key="item.field" span="12">
                  <a-form-model-item :label="$t(item.title)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <component :is="item.type" v-model:value="menu.parameter.business[item.field]" style="width: 100%" v-bind="item.props"/>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </vxe-card>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuOrdinal')">
            <vxe-number-input v-model="menu.ordinal" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.reportNo')">
            <vxe-input v-model="menu.query.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.available')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="menu.available"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.leaf')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="menu.leaf"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import { findAll, findOne, save } from '@/api/Api'
import { Menu } from '@/api/dto/menu/Menu'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'MenuDetail',
  data() {
    return {
      loading: false,
      menu: new Menu(),
      applications: [],
      orderTypes: [],
      positionTypes: [],
      rules: {
        no: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        application: [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  created() {
    findAll('orderTypeFactory', { available: true }).then(res => {
      if (res.success) {
        this.orderTypes = getOptions(res.result)
      }
      return getDictionaries('POSITION_TYPE')
    }).then(result => {
      this.positionTypes = result
      return getEnums('Application')
    }).then(result => {
      this.applications = result
    })
  },
  computed: {
    parameterItems() {
      return [
        {
          type: 'VxeInput',
          field: 'obtainType',
          title: 'business.label.obtainType'
        },
        {
          type: 'VxeNumberInput',
          field: 'pageType',
          title: 'business.label.pageType'
        },
        {
          type: 'VxeSwitch',
          field: 'entire',
          title: 'business.label.entire'
        },
        {
          type: 'VxeSwitch',
          field: 'autoReview',
          title: 'business.label.autoReview'
        },
        {
          type: 'VxeSelect',
          field: 'orderTypeId',
          title: 'business.label.orderType',
          props: {
            options: this.orderTypes
          }
        },
        {
          type: 'VxeSelect',
          field: 'positionTypeId',
          title: 'business.label.positionType',
          props: {
            options: this.positionTypes
          }
        },
        {
          type: 'VxeSelect',
          field: 'positionTypeIds',
          title: 'business.label.positionType',
          props: {
            options: this.positionTypes,
            multiple: true
          }
        }
      ]
    }
  },
  methods: {
    fetch(id) {
      this.loading = true
      findOne('menuFactory', { id: id }).then(res => {
        if (res.success) {
          this.menu = new Menu(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const menu = this.menu.toJSONObject()
          menu.parameter = JSON.stringify(this.menu.parameter)
          save('menuPersister', menu).then(res => {
            if (res.success) {
              this.menu = new Menu(res.result)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    },
    addChildMenu(selectedKey) {
      if (selectedKey.id === null || selectedKey.id === undefined) {
        return this.$notification['error']({
          message: '错误',
          description: '请选择父级节点',
          duration: 4
        })
      }
      this.$refs.form.resetFields()
      this.menu = new Menu()
      this.menu.parent = selectedKey
    },
    addMenu(selectedParentKey) {
      this.$refs.form.resetFields()
      const newData = new Menu()
      this.menu = Object.assign({}, newData)
      this.form.setFieldsValue({ 'parent.id': selectedParentKey })
    },
    refresh() {
      this.menu = new Menu()
      this.$refs.form.resetFields()
    }
  }
}
</script>